import * as React from 'react';
import styled from 'astroturf/react';
import { Icon } from './Icon';
import _Container from "Badge-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Badge.tsx?styleId=Container";


interface Props {
  text: string | React.ReactNode;
  icon?: string;
  iconSize?: number;
  color?: string;
  backgroundColor?: string;
  height?: string;
  style?: React.CSSProperties;
}

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

// A small text label with a colored background to highlight or draw attention to details.
const Badge: React.FC<Props> = ({
  text,
  icon,
  iconSize = 20,
  color,
  backgroundColor,
  height,
  style = {},
}) => {
  const iconView = icon ? <Icon name={icon} size={iconSize} /> : null;

  return (
    <Container style={{ ...style, height, color, backgroundColor }}>
      {iconView ? iconView : null}
      {text}
    </Container>
  );
};

export default Badge;
